import { render, staticRenderFns } from "./Politicas.vue?vue&type=template&id=9c858694"
import script from "./Politicas.vue?vue&type=script&lang=js"
export * from "./Politicas.vue?vue&type=script&lang=js"
import style0 from "./Politicas.vue?vue&type=style&index=0&id=9c858694&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports